import type React from 'react';
import { forwardRef } from 'react';
import { palette } from '../../theme';
import { styled } from '@mui/material/styles';

const TooltipButton = styled('button')(() => ({
  cursor: 'pointer',
  backgroundColor: 'transparent',
  border: '1px solid transparent',
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  height: '18px',
  padding: 0,
  position: 'relative',
  width: '18px',
  '&:focus': {
    borderRadius: '4px',
  },
}));

type TriggerProps = {
  onTriggerToggle: () => void;
  arialLabel?: string;
  minHeight?: string | number;
  minWidth?: string | number;
  triggerIconHeight?: string | number;
  triggerIconWidth?: string | number;
  color?: string;
};

const TooltipTrigger = forwardRef<HTMLButtonElement, React.PropsWithChildren<TriggerProps>>(
  (props, ref) => {
    return (
      <TooltipButton
        type="button"
        ref={ref}
        aria-label={props.arialLabel}
        sx={{
          width: 'fit-content',
          minHeight: props.minHeight ?? '24px',
          minWidth: props.minWidth ?? '24px',
        }}
        onClick={e => {
          e.preventDefault();
          props.onTriggerToggle();
        }}
      >
        {props.children ?? (
          <span
            aria-hidden="true"
            className="mask-icon mask-icon-help-outline"
            style={{
              width: props.triggerIconWidth || '16px',
              height: props.triggerIconHeight || '16px',
              backgroundColor: props.color || palette.grey[500],
            }}
          />
        )}
      </TooltipButton>
    );
  },
);

export default TooltipTrigger;
